import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import JourneyDetail from './pages/JourneyDetail';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import Channels from './pages/Channels';
import Integrations from './pages/Integrations';
import ServicePayments from './pages/ServicePayments';
import ReferralLinks from './pages/ReferralLinks';
import Audience from './pages/Audience';
import Events from './pages/Events';
import Content from './pages/Content';
import ChannelAnalytics from './pages/ChannelAnalytics';
import Subscription from './pages/Subscription';
import Roadmap from './pages/Roadmap';
import Partners from './pages/Partners';
import Support from './pages/Support';
import AddSource from './pages/AddSource';
import Login from './pages/Login';
import TgLogin from './pages/TgLogin';
import './App.css';

function RequireAuth({ children }) {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/tg-login" element={<TgLogin />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/channel-analytics" element={<ChannelAnalytics />} />
                  <Route path="/audience" element={<Audience />} />
                  <Route path="/content" element={<Content />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/journey/:id" element={<JourneyDetail />} />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/channels" element={<Channels />} />
                  <Route path="/integrations" element={<Integrations />} />
                  <Route path="/admin/payments" element={<ServicePayments />} />
                  <Route path="/referral-links" element={<ReferralLinks />} />
                  <Route path="/subscription" element={<Subscription />} />
                  <Route path="/roadmap" element={<Roadmap />} />
                  <Route path="/partners" element={<Partners />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="/add-source" element={<AddSource />} />
                </Routes>
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
